/**
 * Helper method for scrolling to the top of the window.
 * Use this method instead of propogating window.scrollTo(0, 0) throughout our codebase.
 */
export const scrollWindowToTop = (behavior?: ScrollBehavior) => window.scrollTo({ top: 0, left: 0, behavior }); // eslint-disable-line ban/ban
